<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline title="Assigned Services"> -->
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="4" class="my-0 py-0">
          <div clasuccessss="d-flex grow flex-wrap">
            <div class="ml-2">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Assigned Services
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <v-card-actions>
            <a @click="$router.back()">
              <v-btn small v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
                <v-icon left>mdi-arrow-left</v-icon>back
              </v-btn>
              <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
                class="mr-n2 mt-10" style="opacity:.6;">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </a>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-card-component>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row v-if="studentInfo">
            <v-col cols="12" md="2" sm="4">
              <v-img :src="tots_image" width="120"></v-img>
            </v-col>
            <v-col cols="12" v-if="studentInfo.enquiryCode" sm="6" md="4" lg="2">
              <div class="grey--text text-subtitle-2 mb-1">
                Enquiry Code
              </div>
              <div class=" mb-1 font-weight-bold" v-text="studentInfo.enquiryCode"></div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="grey--text text-subtitle-2 mb-1">
                Student Name
              </div>
              <div class=" mb-1 font-weight-bold"
                v-text="studentInfo.studentFirstName ? studentInfo.studentFirstName + ' ' + (studentInfo.studentLastName !== null ? studentInfo.studentLastName : '') : studentInfo.studentName">
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4" v-if="studentInfo.franchisee">
              <div class="grey--text text-subtitle-2 mb-1">
                Franchisee Name
              </div>
              <div class=" mb-1 font-weight-bold"
                v-text="studentInfo.serviceRegistration.franchisee.companyName || ''"></div>
            </v-col>
            <v-col cols="12" md="2" sm="4" v-if="studentInfo.academicYear">
              <div class="grey--text text-subtitle-2 mb-1">
                Academic Year
              </div>
              <div class=" mb-1 font-weight-bold"
                v-text="studentInfo.academicYear.academicYear || ''"></div>
            </v-col>
            <v-col cols="12" md="2" sm="4" v-if="studentInfo.studentClass">
              <div class="grey--text text-subtitle-2 mb-1">
                Class
              </div>
              <div class=" mb-1 font-weight-bold" v-text="studentInfo.studentClass.name || ''">
              </div>
            </v-col>

            <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherName">
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Name
              </div>
              <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherName"></div>
            </v-col>
            <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherMobile">
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Mobile
              </div>
              <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherMobile || ''"></div>
            </v-col>
            <v-col cols="12" md="4" v-if="studentInfo.fatherEmailID">
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Email
              </div>
              <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherEmailID || ''"></div>
            </v-col>
            <v-col cols="12" md="2" sm="4" v-if="studentInfo.gender">
              <div class="grey--text text-subtitle-2 mb-1">
                Student Gender
              </div>
              <!-- <div class="mb-1 font-weight-bold" v-text="studentInfo.gender || ''"></div> -->
              <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'"
                class="mb-1 font-weight-bold"
                v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'">
              </div>
              <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'"
                class="mb-1 font-weight-bold"
                v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'">
              </div>
              <div v-if="studentInfo.gender === null" class="mb-1">--</div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card class="px-2" flat>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete label="Service Category*" class="my-0 py-1" placeholder="--Select--"
                  @change="getServiceList" required hide-details="" v-model.trim="serviceCategoryID"
                  :items="serviceCategories" key="id" item-value="id" item-text="name">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete hide-details="" label="Select Service Type*" @change="() => {
                      ;(page = 1), getAssignedFeePlan()
                    }" class="my-0 py-1" required :items="servicesList" key="id"
                  placeholder="--Select--" name="name" item-text="name" item-value="id"
                  v-model="serviceID">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <span class="body-2 font-weight-medium ma-1"> From date</span>
            <custom-date-picker hidden-details="true" :maxToDate="maxToDate"
              v-model.trim="fromDate" />
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <span class="body-2 font-weight-medium"> To date</span>
            <custom-date-picker :minToDate="fromDate" v-model.trim="toDate" />
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-btn class="mt-6" hide-details mediun small color="success" type="submit" @click="
                        () => {
                          getAssignedFeePlan(), (page = 1)
                        }
                      ">
              <v-icon left> mdi-magnify </v-icon>
              Search
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div v-if="tableInfo.length > 0">
          <div v-for="eachValueOfTableInfo in tableInfo" :key="eachValueOfTableInfo.id">
            <v-card elevation="3" rounded="lg" class="my-4 colouredCard">
              <v-card flat>
                <v-row>
                  <!-- <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium "
                      ><div class="body-1">Service Category :</div>
                      <span class="darkblue--text text-uppercase">
                        {{ eachValueOfTableInfo.serviceType.serviceCategory.name ? eachValueOfTableInfo.serviceType.serviceCategory.name : '-' }}</span
                      ></v-card-subtitle
                    ></v-col
                  > -->
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium ">
                      <div class="body-1">Service Type Name :</div>
                      <span class="accent--text text-uppercase">
                        {{ eachValueOfTableInfo.serviceType.name ? eachValueOfTableInfo.serviceType.name : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium ">
                      <div class="body-1">Plan Name :</div>
                      <span class="pink--text text-capitalize">
                        {{ eachValueOfTableInfo.assignFeeComponent.name ? eachValueOfTableInfo.assignFeeComponent.name : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>
                  <!-- <v-col cols="12" md="4" sm="6">
                              <v-card-subtitle class="font-weight-medium "
                                ><div class="body-1">Description :</div>
                                <span class="primary--text"> {{ servicePlan.description ? servicePlan.description : '-' }}</span></v-card-subtitle
                              >
                            </v-col> -->

                  <!-- <v-col cols="12" md="2" sm="6">
                              <v-card-subtitle class="font-weight-medium"
                                ><div class="body-2">Year :</div>
                                <span class="primary--text">
                                  {{
                                    eachValueOfTableInfo.assignFeeComponent.franchiseeAcademicYear && eachValueOfTableInfo.assignFeeComponent.franchiseeAcademicYear.academicYear
                                      ? eachValueOfTableInfo.assignFeeComponent.franchiseeAcademicYear.academicYear
                                      : '-'
                                  }}</span
                                ></v-card-subtitle
                              >
                            </v-col> -->
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Plan Start Date :</div>
                      <span class="primary--text">
                        {{ eachValueOfTableInfo && eachValueOfTableInfo.startDate ? new Date(eachValueOfTableInfo.startDate).toLocaleDateString() : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Plan End Date :</div>
                      <span class="primary--text">
                        {{ eachValueOfTableInfo.endDate ? new Date(eachValueOfTableInfo.endDate).toLocaleDateString() : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>

                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Amount :</div>
                      <span class="secondary--text font-weight-bold">
                        {{ eachValueOfTableInfo.assignFeeComponent.amount ? eachValueOfTableInfo.assignFeeComponent.amount : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Status :</div>
                      <span :class="getColor(eachValueOfTableInfo.status)">
                        {{ eachValueOfTableInfo.status ? eachValueOfTableInfo.status : '-' }}</span>
                    </v-card-subtitle>
                  </v-col>

                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Description :</div>
                      <span v-if="!eachValueOfTableInfo.serviceType.description">NA</span>
                      <div v-html="eachValueOfTableInfo.serviceType.description"></div>
                    </v-card-subtitle>
                  </v-col>
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium">
                      <div class="body-2">Plan Status :</div>
                      <span class="info--text font-weight-bold">
                        {{ eachValueOfTableInfo.isActive ? 'Active' : 'Inactive' }}</span>
                    </v-card-subtitle>
                  </v-col>

                </v-row>

                <v-divider class="my-0"></v-divider>
                <v-row justify="end">
                  <!-- <v-col cols="12" md="2" sm="6" class="d-flex align-center">
                  <router-link :to="{ name: 'servicePlanDetails', params: { enquiryID: enquiryID, assignFeeComponentID: eachValueOfTableInfo.assignFeeComponentID, planID: eachValueOfTableInfo.id } }">

                    <v-btn outlined class="px-2 ml-1 ma-1" >
                      Ledger
                    </v-btn>
                  </router-link>
                </v-col> -->
                  <v-col cols="12" md="2" sm="6" class="mr-4">
                    <v-btn v-if="eachValueOfTableInfo.isActive"
                      @click="changeStatusAssignedService(eachValueOfTableInfo.id)" dark
                      class="px-2 ml-1 ma-1" elevation="1" color="red"> In Active <v-icon right>
                        mdi-light-switch</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="2" sm="6" class="mr-4">
                    <router-link
                      :to="{ name: 'ServicesPaymentOptions', params: { enquiryID: enquiryID, assignFeeComponentID: eachValueOfTableInfo.assignFeeComponentID, planID: eachValueOfTableInfo.id } }">
                      <v-btn dark class="px-2 ml-1 ma-1" elevation="1" color="pink"> Payment <v-icon
                          right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </div>
        </div>
        <v-col v-if="tableInfo.length != 0">
          <v-row>
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
                @change="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" :length="totalPages" :total-visible="10"
                @input="handlePageChange"></v-pagination>
            </v-col>
          </v-row>
        </v-col>
        <v-card-component v-else>
          <v-card-title class="d-flex justify-center">No Data</v-card-title>
        </v-card-component>
      </v-card-component>
    </v-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'
import CustomDatePicker from '@/components/template/CustomDatePicker'

// import MaterialCard from '@/components/template/MaterialCard'

export default {
  components: {
    //   MaterialCard,
    VCardComponent,
    CustomDatePicker
  },
  props: ['enquiryID'],
  data () {
    return {
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      fromDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      tots_image: `${CONSTANTS.RAZORPAY.TOTS_IMAGE}`,
      isLoading: false,
      serviceCategories: [],
      serviceCategoryID: '',
      valid: true,
      studentInfo: {},
      tableInfo: [],
      tbdata2: [],
      search: '',
      servicesList: [],
      serviceID: '',
      filter: {
        fromDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Enquiry Code', value: 'assignFeeComponent.enquiry.enquiryCode', sortable: true },
        { text: 'Service Name', value: 'serviceType.name', sortable: true },
        { text: 'Fee Plan', value: 'assignFeeComponent.feeComponent.name', sortable: true },
        { text: 'Franchisee', value: 'assignFeeComponent.franchisee.companyName', sortable: true },
        { text: 'Acadamic year', value: 'assignFeeComponent.franchiseeAcademicYear.academicYear', sortable: true },
        { text: 'Created AT', value: 'createdAt', sortable: true },
        { text: 'status', value: 'status', sortable: true },
        { text: 'isActive', value: 'isActive', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  created: async function () {
    await this.onstart()
  },

  methods: {
    onstart: async function () {
      await this.getCategories()
      await this.getStudentData()
      await this.getAssignedFeePlan()
    },
    changeStatusAssignedService: async function (id) {
      try {
        let res = await http.put(`${CONSTANTS.API_URL}/api/student/service/inactive-plan/${id}`)
        this.getAssignedFeePlan()
        this.okMsg(res.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getCategories: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/service/category/type/list?enquiryID=${this.enquiryID}&isRequired=true`)
        this.serviceCategories = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getServiceList: async function () {
      console.log(this.academicYearID, 'this.academicYearID', this.serviceCategoryID, 'this.serviceCategoryID', this.franchiseeID, 'this.franchiseeID')
      if (this.academicYearID && this.serviceCategoryID && this.franchiseeID) {
        try {
          let { data } = await http.get(
            `${CONSTANTS.API_URL}/api/service/type/list/?academicYearID=${this.academicYearID}&&categoryID=${this.serviceCategoryID}&&franchiseeID=${this.franchiseeID}&&isActive=true`
          )

          this.servicesList = data
          if (this.servicesList.length === 0) {
            return this.$dialog.message.error('No service type Available', {
              position: 'top',
              timeout: 4000
            })
          }
          console.log(this.servicesList, 'serviceList')
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
        }
      }
    },
    getAssignedFeePlan: async function () {
      try {
        this.isLoading = true
        // let url = `${CONSTANTS.API_URL}/api/student/service/assign-fee-components/status?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&enquiryID=${this.enquiryID}&&page=${this.page - 1}&&size=${this.size}&&fromDate=${this.fromDate}&toDate=${this.toDate}`
        // url += +!!this.serviceID ? `&&serviceTypeID=${this.serviceID}` : ''
        const paramData = {}
        paramData.franchiseeID = this.franchiseeID
        paramData.academicYearID = this.academicYearID
        paramData.enquiryID = this.enquiryID
        paramData.page = this.page - 1
        paramData.size = this.pageSize
        if (this.fromDate) {
          paramData.fromDate = this.fromDate
        }
        if (this.toDate) {
          paramData.toDate = this.toDate
        }
        if (this.serviceID) {
          paramData.serviceTypeID = this.serviceID
        }
        paramData.isActive = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/student/service/assign-fee-components/status`, {
          params: paramData
        })
        this.tableInfo = res.data.rows
        console.log(this.tableInfo)
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getAssignedFeePlan()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getAssignedFeePlan()
    },
    getStudentData: async function () {
      try {
        this.isLoading = true
        // let res = await http.get(`${CONSTANTS.API_URL}/api/student/service/fee-plan/${this.enquiryID}`)
        let res = await http.get(`${CONSTANTS.API_URL}/api/student/service/fee-plan`, {
          params: {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYearID,
            isRequired: false,
            enquiryID: this.enquiryID,
            startDate: this.filter.fromDate,
            endDate: this.filter.toDate
          }
        })
        this.studentInfo = res.data[0]
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID) {
          await this.getAssignedFeePlan()
        }
        if (this.academicYearID) {
          await this.getServiceList()
        }
        if (this.enquiryID && this.franchiseeID && this.academicYearID) {
          this.getStudentData()
        }
        this.inProgress = false
      }
    },
    getColor (status) {
      if (status === 'APPROVED') return 'success--text font-weight-bold'
      else if (status === 'REJECTED') return 'error--text font-weight-bold'
      else if (status === 'APPLIED') return 'darkblue--text font-weight-bold'
      else if (status === 'PENDING') return 'warning--text font-weight-bold'
      else return 'secondary--text'
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    }
  }
}
</script>
<style lang="css">
/* .colouredCard {
  background: #f2f2f2 !important;
} */
</style>
